import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'admin-components/components';
import { FormattedMessage } from 'react-intl';
import { ConfirmButton, CancelButton } from 'components/ui/Button';
import { ButtonContainer } from './AmendBookingCta.styles';

const AmendBookingCta = ({
  redirect,
  isNewMealsSelection,
  areNewSeatsSelected,
  isUpdatingSeats,
  updatePassengerSeats,
  updateMeals,
  isUpdatingMeals,
  disabledContinue
}) => {
  const hasChanges = isNewMealsSelection || areNewSeatsSelected;
  const ButtonToRender = hasChanges ? ConfirmButton : CancelButton;

  return (
    <>
      {isUpdatingSeats || isUpdatingMeals ? (
        <Spinner />
      ) : (
        <ButtonContainer>
          <ButtonToRender
            id="btn-save-close"
            disabled={disabledContinue}
            onClick={async () => {
              await updatePassengerSeats();

              if (isNewMealsSelection) {
                await updateMeals();
              }

              return redirect();
            }}
          >
            <FormattedMessage id={`changeMeal.${hasChanges ? 'saveAndClose' : 'close'}`} />
          </ButtonToRender>
        </ButtonContainer>
      )}
    </>
  );
};

AmendBookingCta.propTypes = {
  redirect: PropTypes.func,
  updateMeals: PropTypes.func,
  isNewMealsSelection: PropTypes.bool,
  areNewSeatsSelected: PropTypes.bool,
  isUpdatingSeats: PropTypes.bool,
  isUpdatingMeals: PropTypes.bool,
  updatePassengerSeats: PropTypes.func,
  disabledContinue: PropTypes.bool
};

export default AmendBookingCta;
